// תמונה ממוזערת חיה של וריאציה: אותו runtime, seek לפריים הסיום.
import { useEffect, useState } from 'react';
import { api } from '../../api';
import BannerView, { fitScale } from './BannerView';
import type { VariantCtx } from './types';

export function useVariantCtx(id: string, revisionKey?: unknown) {
  const [ctx, setCtx] = useState<VariantCtx | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    api.get<VariantCtx>(`/api/variants/${id}`).then((c) => { if (alive) setCtx(c); }).catch((e) => { if (alive) setErr(e.message); });
    return () => { alive = false; };
  }, [id, revisionKey]);
  return { ctx, err };
}

export default function VariantThumb({ ctx, maxW = 300, maxH = 250 }: { ctx: VariantCtx | null; maxW?: number; maxH?: number }) {
  if (!ctx) return <div className="bv-frame" style={{ width: maxW / 2, height: maxH / 2 }}><span className="spinner" /></div>;
  if (!ctx.revision) return <div className="small muted">אין גרסה</div>;
  const d = ctx.revision.doc;
  return <BannerView doc={d} assets={ctx.assets} at="end" scale={fitScale(d.width, d.height, maxW, maxH)} label={`פריים סיום ${d.width}x${d.height}`} />;
}
